import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      d: "M10.05 19.15h4m-4-4.2 1.3-1.3c.1-.1.3-.2.4-.2s.2.1.2.2v5.5"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      d: "M23.25 21.75c0 .8-.7 1.5-1.5 1.5H2.25c-.8 0-1.5-.7-1.5-1.5V5.25c0-.8.7-1.5 1.5-1.5h19.5c.8 0 1.5.7 1.5 1.5zm-22.5-13h22.5m-16.4-2.8V.75m10.4 5.2V.75"
    }, null, -1)
  ]));
}
const interfaceCalendarDateOne = { render };
export {
  interfaceCalendarDateOne as default,
  render
};
//# sourceMappingURL=interface-calendar-date-one.svg.js.map
